import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Query } from "apollo-angular";
import { Exact } from "src/generated/graphql";
import { IndicatorCalculation } from "src/app/model/indicatorCalculation";

export type GetIndicatorCalculationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIndicatorCalculationsQuery = {
  getIndicatorCalculations: IndicatorCalculation[];
};

export const GetIndicatorCalculationsDocument = gql`
  query GetIndicatorCalculations {
    getIndicatorCalculations {
      id
      indicator
      reductionType
      metric
      conversionFactor
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetIndicatorCalculationsGQL extends Query<
  GetIndicatorCalculationsQuery,
  GetIndicatorCalculationsQueryVariables
> {
  document = GetIndicatorCalculationsDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
